import React from 'react';
import { List, Edit, Create, Show, SimpleShowLayout,
    Datagrid, ReferenceField, TextField, DateField, EditButton,
    SimpleForm, DateInput, ReferenceInput, SelectInput } from 'admin-on-rest';

export const LevyShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <ReferenceField label="Client" source="client.id" reference="client" linkType="show">
                <TextField source="companyName" />
            </ReferenceField>
            <ReferenceField label="Contrat" source="contract.id" reference="contract" linkType="show">
                <TextField source="reason" />
            </ReferenceField>
            <DateField label="Date de prélèvement" source="collectionDate" />
            <TextField label="Statut" source="status"/>
            <TextField label="E2E" source="end2endId"/>
            <TextField label="Mandate ID" source="mandateId"/>
        </SimpleShowLayout>
    </Show>
);

export const LevyCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <ReferenceInput label="Client" source="client" reference="client" allowEmpty>
                <SelectInput optionText="companyName" />
            </ReferenceInput>
            <DateInput label="Date de prélèvement" source="collectionDate" />
        </SimpleForm>
    </Create>
);

export const LevyList = (props) => (
    <List title="Tous les prélèvements" {...props}>
        <Datagrid>
            <ReferenceField label="Client" source="client.id" reference="client" linkType="show">
                <TextField source="companyName" />
            </ReferenceField>
            <ReferenceField label="Contrat" source="contract.id" reference="contract" linkType="show">
                <TextField source="reason" />
            </ReferenceField>
            <DateField label="Date de prélèvement" source="collectionDate" />
            <TextField label="Statut" source="status" />
            <TextField label="E2E" source="end2endId"/>
            <TextField label="Mandate ID" source="mandateId"/>
            <EditButton />
        </Datagrid>
    </List>
);

export const LevyEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <ReferenceInput label="Client" source="client.id" reference="client">
                <SelectInput optionText="companyName" />
            </ReferenceInput>
            <DateInput label="Date de prélèvement" source="collectionDate" />
            <SelectInput label="Statut" source="status" choices={[
                { id: 'pending', name: 'En cours' },
                { id: 'approved', name: 'Approuvé' },
                { id: 'denied', name: 'Rejeté' },
            ]} />
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// src/resources/levies.js